// // PAGES FOR AFTER THE LINK IN EMAIL IS CLICKED //

// import React, { useState, useEffect } from 'react';
// import { NavLink } from 'react-router-dom';
// import { useSearchParams, useNavigate } from "react-router-dom";
// import FormInput from '../../components/Form/FormInput/FormInput';
// import { resetPasswordAPI, verifyEmailAPI } from '../../api/auth';
// import lockIcon from "../../assets/media/icon/lock1.png";

export default function UserAuth() {}
//     const [searchParams] = useSearchParams();
//     let mode = searchParams.get('mode');
//     let oobCode = searchParams.get('oobCode');

//     if (mode === 'resetPassword') {
//         return <ResetPasswordPage oobCode={oobCode} />;
//     } else if (mode === 'verifyEmail') {
//         return <EmailVerificationSuccessMessage oobCode={oobCode} />;
//     }
// }

// function ResetPasswordPage({ oobCode }: { oobCode: string | null; }) {
//     const navigate = useNavigate();
//     const [successMessage, setSuccessMessage] = useState(false);
//     const [password, setPassword] = useState("");
//     const [confirmPassword, setConfirmPassword] = useState("");

//     const resetFormFields = () => {
//         setPassword("");
//         setConfirmPassword("");
//     };

//     const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
//         e.preventDefault();

//         if (password !== confirmPassword) {
//             alert("Passwords did not match.");
//             return;
//         }

//         try {
//             if (oobCode) {
//                 await resetPasswordAPI({ oobCode, confirmPassword });
//                 resetFormFields();
//                 setSuccessMessage(true);
//             } else {
//                 alert('Something is wrong; try again later!');
//             }
//         } catch (error: any) {
//             if (error.code === 'auth/invalid-action-code') {
//                 alert('Something is wrong; try again later.');
//             }
//         }
//     };

//     return (
//         <div className="forgot-password-page">
//             {
//                 successMessage ?
//                     <div>
//                         <h3>Success! Your Password change successfully</h3>
//                         <button onClick={() => navigate('/login')} style={{ textDecoration: "underline" }}>
//                             Go to the Login page
//                         </button>
//                     </div>
//                     :
//                     <>
//                         <div className="login-container forget-password-container">
//                             <h2>Reset password</h2>
//                             <form id="form-login" onSubmit={handleSubmit}>
//                                 <FormInput input={{ class: "static", label: "Password", type: "password", value: password, img: lockIcon, placeholder: "", required: true, update: (value: string) => { setPassword(value); } }} />
//                                 <FormInput input={{ class: "static", label: "Confirm Password", type: "password", value: confirmPassword, img: lockIcon, placeholder: "", required: true, update: (value: string) => { setConfirmPassword(value); } }} />
//                                 <button id="login-button" type="submit" style={{ marginBottom: "10px" }}>Reset password</button>
//                             </form>
//                             <NavLink to="/login" style={{ textDecoration: "underline", color: "var(--dark-blue)" }}>Back to login</NavLink>
//                         </div>
//                     </>
//             }
//         </div>
//     );
// }

// function EmailVerificationSuccessMessage({ oobCode }: { oobCode: string | null; }) {
//     const navigate = useNavigate();
//     const [confirmEmailSuccess, setConfirmEmailSucess] = useState(false);

//     useEffect(() => {
//         (async () => {
//             if (oobCode) {
//                 try {
//                     const response = await verifyEmailAPI(oobCode);
//                     if (response && response.status) {
//                         setConfirmEmailSucess(true);
//                     }
//                 } catch (error) {
//                     alert(error);
//                 }
//             }
//         })();
//     }, []);

//     return (
//         <div className="confirm-email-thank-you" style={{ display: "flex", flexDirection: "column", alignItems: "center", margin: "100px 0" }}>
//             {confirmEmailSuccess && oobCode ?
//                 <div>
//                     <h3>Thank you!</h3>
//                     <button onClick={() => navigate('/login')}>Login</button>
//                 </div>
//                 :
//                 <div>
//                     <h3>There was a problem confirming your email.</h3>
//                     <p>If the problem persists, please contact <a href={`mailto:example@email.com`}>example@email.com</a></p>
//                     <button onClick={() => navigate('/')}>Back to Home Page</button>
//                 </div>
//             }
//         </div>
//     );
// }
